
const twoRouter = {
  path: '/',
  component: () => import('@/components/report/home.vue'),
  children: [
    {
      path: '/report/eff-survey',
      name: 'eff_survey',
      component: () => import('@/components/report/efficiency/survey/index.vue')
    },
    {
      path: '/report/eff-target',
      name: 'eff_target',
      component: () => import('@/components/report/efficiency/target/index.vue')
    },
    {
      path: '/report/eff-trend',
      name: 'eff_trend',
      component: () => import('@/components/report/efficiency/trend/index.vue')
    },
    {
      path: '/report/eff_therapist',
      name: 'eff_therapist',
      component: () => import('@/components/report/efficiency/therapist/eff_therapist.vue')
    },
    {
      path: '/report/eff_store',
      name: 'eff_store',
      component: () => import('@/components/report/efficiency/contrast/eff_store.vue')
    },
    // 理疗师
    {
      path: '/report/perform_survey',
      name: 'perform_survey',
      component: () => import('@/components/report/performance/survey/perform_survey.vue')
    },
    {
      path: '/report/perform_target_trend',
      name: 'perform_target_trend',
      component: () => import('@/components/report/performance/target/perform_target.vue')
    },
    {
      path: '/report/perform_contrast',
      name: 'perform_contrast',
      component: () => import('@/components/report/performance/contrast/perform_contrast.vue')
    },
    {
      path: '/report/perform_analyze',
      name: 'perform_analyze',
      component: () => import('@/components/report/performance/analyze/perform_analyze.vue')
    },
    // 前台
    // 概况
    {
      path: '/report/front_survey',
      name: 'front_survey',
      component: () => import('@/components/report/receptionist/survey/front_survey.vue')
    },
    // 详情
    {
      path: '/report/front_detail',
      name: 'front_detail',
      component: () => import('@/components/report/receptionist/detail/front_detail.vue')
    },
    // 增长
    {
      path: '/report/front_analyze',
      name: 'front_analyze',
      component: () => import('@/components/report/receptionist/analyze/front_analyze.vue')
    },
    // 对比
    {
      path: '/report/front_contract',
      name: 'front_contract',
      component: () => import('@/components/report/receptionist/contrast/front_contract.vue')
    },
  ]
}

export default twoRouter
